import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useMultiResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedAndNamedArtifactResource,
    IndirectlyVersionedAndNamedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';

export enum ActivitiesPropertyValidation {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
}

export const ActivitiesResourceSchema = IndirectlyVersionedAndNamedArtifactResourceSchema.extend({
    resourceType: z.literal(ResourceType.ACTIVITIES).default(ResourceType.ACTIVITIES),
    description: z.string(),
});
export const ActivitiesMutationResourceSchema = getMutationSchema(ActivitiesResourceSchema);

export type ActivitiesResource = z.infer<typeof ActivitiesResourceSchema>;

export const defaultActivitiesResource: ActivitiesResource = {
    ...defaultIndirectlyVersionedAndNamedArtifactResource,
    resourceType: ResourceType.ACTIVITIES,
    description: '',
};

export function useActivitiesActions() {
    return {
        ...useMultiResourceSingleParentedResourceAdapterActions(
            'project/activities',
            ResourceType.ACTIVITIES,
            ActivitiesResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter(
            'project/activities',
            ResourceType.ACTIVITIES,
            ActivitiesResourceSchema
        ),
    };
}
